import React from 'react'
import { useNavigate } from 'react-router-dom'
import { PlusCircle, Search, Users, ArrowRight, Dna } from 'lucide-react'
import './CreateResearchGroupInfo.css'

const CreateResearchGroupInfo = () => {
  const navigate = useNavigate()

  return (
    <div className="join-research-page">
      <div className="join-hero">
        <div className="join-hero-content">
          <h1>
            <PlusCircle size={40} className="hero-icon" />
            Crea tu Grupo de Investigación
          </h1>
          <p>Lidera la innovación. Plantea tu propia línea de investigación y reúne a las mentes más brillantes de la universidad bajo un objetivo común.</p>
        </div>
      </div>

      <div className="join-container">
        <section className="join-section">
          <h2>¿Por qué fundar un nuevo grupo?</h2>
          <div className="benefits-grid">
            <div className="benefit-card">
              <Dna size={32} className="benefit-icon" />
              <h3>Innovación Independiente</h3>
              <p>Define tus propias hipótesis y traza el camino para explorarlas sin las ataduras de temáticas preestablecidas.</p>
            </div>
            <div className="benefit-card">
              <Users size={32} className="benefit-icon" />
              <h3>Liderazgo Científico</h3>
              <p>Capacita a otros estudiantes, delega tareas e impulsa el crecimiento académico colaborativo.</p>
            </div>
            <div className="benefit-card">
              <Search size={32} className="benefit-icon" />
              <h3>Reconocimiento Oficial</h3>
              <p>Obtén aval y visibilidad en tus proyectos para futuras ferias científicas y publicaciones indexadas.</p>
            </div>
          </div>
        </section>

        <section className="join-section step-instruction-section">
          <h2>Pasos para crear un grupo</h2>
          <div className="steps-container">
            <div className="step-item">
              <div className="step-number">1</div>
              <div className="step-text">
                <h3>Prepara tu Propuesta</h3>
                <p>Define el nombre de tu grupo, sus siglas y un resumen de las metas o líneas de investigación que van a seguir.</p>
                <div className="step-action-link">
                  <button className="link-text-btn" onClick={() => navigate('/formularios-investigacion')}>
                    haz clic aquí para ver que debes subir (formularios oficiales)
                  </button>
                </div>
              </div>
            </div>
            
            <div className="step-item">
              <div className="step-number">2</div>
              <div className="step-text">
                <h3>Revisión y Aceptación</h3>
                <p>El Administrador, junto a un consejo de al menos <strong>2 alumnos del voluntariado</strong>, evaluarán tu propuesta. Podrán aceptar el grupo directamente o realizar ajustes y revisiones según los objetivos planteados.</p>
              </div>
            </div>

            <div className="step-item">
              <div className="step-number">3</div>
              <div className="step-text">
                <h3>Publicación Oficial</h3>
                <p>Si la propuesta es aceptada, se procederá a la <strong>creación del expediente</strong> y la publicación del grupo en la web oficial. Podrás definir una Palabra Clave para que solo personas autorizadas se unan.</p>
              </div>
            </div>
          </div>
        </section>

        <section className="join-action-section">
          <h2>¿Listo para empezar tu propio grupo?</h2>
          <p>Regístrate o inicia sesión como Tutor/Investigador para acceder a la plataforma de creación oficial.</p>
          <div className="action-buttons">
            <button className="primary-action-button" onClick={() => navigate('/register')}>
              Registrarse y Comenzar <ArrowRight size={20} />
            </button>
            <button className="secondary-action-button" onClick={() => navigate('/login')}>
              Ya tengo cuenta
            </button>
          </div>
        </section>
      </div>
    </div>
  )
}

export default CreateResearchGroupInfo
